<template>
  <div v-if="items">
    <p align="center" style="text-align:center"><b><span style="font-size:12.0pt"><span style="font-family:&quot;Arial&quot;,sans-serif">Отчет по менеджерам о статусе комплексной диагностики компаний </span></span></b></p>

    <table class="MsoTableGrid" style="width:500.9pt; border-collapse:collapse; border:solid windowtext 1.0pt" width="668">
      <tbody>
      <tr style="height:24.05pt">
        <td rowspan="2" style="width:35.35pt; border:solid windowtext 1.0pt" width="47">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:24.05pt"><b><span style="font-size:11.0pt"><span style="font-family:&quot;Arial&quot;,sans-serif">№№</span></span></b></span></p>
        </td>
        <td rowspan="2" style="width:191.2pt; border:solid windowtext 1.0pt; border-left:none" width="255">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:24.05pt"><b><span style="font-size:11.0pt"><span style="font-family:&quot;Arial&quot;,sans-serif">Менеджер</span></span></b></span></p>
        </td>
        <td colspan="3" style="width:274.35pt; border:solid windowtext 1.0pt; border-left:none" width="366">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:24.05pt"><b><span style="font-size:11.0pt"><span style="font-family:&quot;Arial&quot;,sans-serif">Статус компаний</span></span></b></span></p>
        </td>
      </tr>
      <tr style="height:32.75pt">
        <td style="width:106.65pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="142">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:32.75pt"><b><span style="font-size:11.0pt"><span style="font-family:&quot;Arial&quot;,sans-serif">В процессе диагностики</span></span></b></span></p>
        </td>
        <td style="width:61.7pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="82">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:32.75pt"><b><span style="font-size:11.0pt"><span style="font-family:&quot;Arial&quot;,sans-serif">Архив </span></span></b></span></p>
        </td>
        <td style="width:106.0pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="141">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:32.75pt"><b><span style="font-size:11.0pt"><span style="font-family:&quot;Arial&quot;,sans-serif">Завершили диагностику</span></span></b></span></p>
        </td>
      </tr>
      <tr v-for="(item, key) in items" :key="key" style="height:20.85pt">
        <td style="width:35.35pt; border:solid windowtext 1.0pt; border-top:none" width="47">
          <p style="padding:0cm 5.4pt 0cm 5.4pt"><span style="height:20.85pt"><span style="font-size:11.0pt"><span style="font-family:&quot;Arial&quot;,sans-serif">{{key + 1}}.</span></span></span></p>
        </td>
        <td style="width:191.2pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="255">
          <p style="padding:0cm 5.4pt 0cm 5.4pt"><span style="height:20.85pt"><span style="font-size:11.0pt"><span style="font-family:&quot;Arial&quot;,sans-serif">{{item.user}}</span></span></span></p>
        </td>
        <td style="width:106.65pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="142">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:20.85pt"><span style="font-size:11.0pt"><span style="font-family:&quot;Arial&quot;,sans-serif">{{item.progress_count}}</span></span></span></p>
        </td>
        <td style="width:61.7pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="82">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:20.85pt"><span style="font-size:11.0pt"><span style="font-family:&quot;Arial&quot;,sans-serif">{{item.archive_count}}</span></span></span></p>
        </td>
        <td style="width:106.0pt; border-top:none; border-left:none; border-bottom:solid windowtext 1.0pt; border-right:solid windowtext 1.0pt" width="141">
          <p align="center" style="text-align:center; padding:0cm 5.4pt 0cm 5.4pt"><span style="height:20.85pt"><span style="font-size:11.0pt"><span style="font-family:&quot;Arial&quot;,sans-serif">{{item.final_count}}</span></span></span></p>
        </td>
      </tr>
      </tbody>
    </table>
    <p><span style="font-size:12.0pt"><span style="font-family:Arial">Регион:  {{ region }}</span></span></p>
    <p><span style="font-size:12.0pt"><span style="font-family:Arial">Дата отчета:  {{ date }}</span></span></p>
  </div>
</template>

<script>
    export default {
        name: "ComplexManagersPrint",
        props: ['items', 'region'],
        data() {
            return {
                date: null
            }
        },
        mounted() {
            let today = new Date(),
                dd = today.getDate(),
                mm = today.getMonth() + 1;
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            this.date = dd + '.' + mm + '.' + today.getFullYear();
        }
    }
</script>

<style scoped>

</style>
